// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".gallery-images[data-v-4f2e9494]{display:-ms-grid;display:grid;gap:20px;grid-template-columns:repeat(auto-fit,minmax(300px,1fr))}.loading-image[data-v-4f2e9494]{display:inline-block;margin:20px auto;width:100px}", ""]);
// Exports
module.exports = exports;
